/**
 * HTTP Header to add Reggora origin context
 */
export const HEADER_REGGORA_ORIGIN = 'rg-origin'
